// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Sc3W","field":"styles_field__cL2OC","fieldCol":"styles_fieldCol__2dxka","diffCol":"styles_diffCol__2Sm9X","diff":"styles_diff__8EzUV"};